import { ChangeEvent, useEffect, useState } from 'react';
import InputField from '@/components/customercenter-ui/common/validateForm/inputField';
import ToolTips from '@/components/customercenter-ui/tooltip';
import SecurityCodeTooltip from '@/components/customercenter-ui/tooltip/securityCode';
import { Checkbox } from '@/components/customercenter-ui/ui/checkbox';
import {
  formatExpiryDate,
  getCardType,
  getMaxlengthCreditCard,
} from '@/components/customercenter-ui/utils/crediCardUtils';
import { useCheckout } from '@/context/checkoutProvider';
import { mapLocaleToMeaningfulFormat } from '@/helpers/utils/i18n';
import { handleCardNumberChange } from './Payment';

export const CARD_NAMES = {
  AMERICAN_EXPRESS: 'amex',
  VISA: 'visa',
  MASTERCARD: 'mastercard',
  DISCOVER: 'discover',
};

interface NewCreditCard {
  register: any;
  errors: any;
  reset: any;
  date?: string;
  isEditCard?: boolean;
}

const NewCreditCard: React.FC<NewCreditCard> = ({ register, errors, date, isEditCard }: any) => {
  const [cardType, setCardType] = useState('');
  const [cardNumber, setCardNumber] = useState('');
  const [expDate, setExpDate] = useState(date ? date : '');
  const { setSaveCard: saveCardContext, checkoutExtraDetails } = useCheckout();
  const loggedIn = false;
  const [saveCard, setSaveCard] = useState(checkoutExtraDetails.saveCard);

  const handleCardNumberInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    handleCardNumberChange(e, setCardNumber);
    const cardType = getCardType(e.target.value);
    setCardType(cardType);
  };

  const handleExpDateInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    const expDate = formatExpiryDate(e.target.value);
    setExpDate(expDate);
  };

  const handleSaveCardCheckboxChange = () => {
    setSaveCard((prev) => !prev);
  };

  useEffect(() => {
    saveCardContext(saveCard);
    setExpDate(date);
  }, [saveCard, date]);

  return (
    <section className="mb-6 max-w-full lg:w-[80%]">
      <section className="relative max-w-[398px]">
        <InputField
          items={mapLocaleToMeaningfulFormat(['*']).cardNumber}
          id={mapLocaleToMeaningfulFormat(['*']).cardNumber}
          htmlFor={mapLocaleToMeaningfulFormat(['*']).cardNumber}
          register={register}
          errors={errors}
          label="cardNumber"
          classname="w-full"
          focusCardNumber={true}
          value={cardNumber}
          onChange={handleCardNumberInputChange}
          cardType={cardType}
          maxlength={getMaxlengthCreditCard(cardType)}
          preventClipboardEvents={true}
        />
        {/* <Discover className="absolute right-3 top-3 h-8 w-12" /> */}
      </section>
      <section className="flex items-center space-x-2 pt-3 lg:space-x-4">
        <section className="w-full max-w-[216px]">
          <InputField
            items={mapLocaleToMeaningfulFormat().expiryDatePlaceholder}
            id={mapLocaleToMeaningfulFormat().expDate}
            htmlFor={mapLocaleToMeaningfulFormat().expDate}
            register={register}
            errors={errors}
            label="expDate"
            classname="w-full"
            value={expDate}
            onChange={handleExpDateInputChange}
            maxlength={5}
          />
        </section>
        <section className="w-full max-w-[158px]">
          <InputField
            items={mapLocaleToMeaningfulFormat().securityCodePlaceholder}
            id={mapLocaleToMeaningfulFormat().securityCodeId}
            htmlFor={mapLocaleToMeaningfulFormat().securityCodeId}
            register={register}
            errors={errors}
            label="securityCode"
            classname="w-full"
            isNum
            maxlength={cardType === 'amex' ? 4 : 3}
          />
        </section>
        <ToolTips className="mb-4" Content={{ ContentToolTip: <SecurityCodeTooltip /> }} />
      </section>
      {loggedIn && !isEditCard && (
        <section className="flex items-center space-x-2">
          <Checkbox
            onCheckedChange={handleSaveCardCheckboxChange}
            defaultChecked={saveCard}
            id="Save card"
            checked={saveCard}
          />
          <label htmlFor="Save card" className="px-2 text-base font-normal leading-6">
            {mapLocaleToMeaningfulFormat().saveThisCard}
          </label>
        </section>
      )}
    </section>
  );
};

export default NewCreditCard;
